import { render, staticRenderFns } from "./dialogCoupon.vue?vue&type=template&id=256a6d65&scoped=true"
import script from "./dialogCoupon.vue?vue&type=script&lang=js"
export * from "./dialogCoupon.vue?vue&type=script&lang=js"
import style0 from "./dialogCoupon.vue?vue&type=style&index=0&id=256a6d65&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256a6d65",
  null
  
)

export default component.exports